import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';

import { FormLabelComponent } from '@ui-kit/form/form-label/form-label.component';

@Component({
    selector: 'dropdown',
    standalone: true,
    imports: [FormsModule, TranslateModule, MultiSelectModule, SelectModule, FormLabelComponent],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent {
    id = input.required<string>();
    value = model.required<any>();
    options = input.required<any[]>();

    multiple = input<boolean>(false);
    optionDisabled = input<string | undefined>(undefined);

    optionLabel = input<string | undefined>('text');
    optionValue = input<string | undefined>('value');

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    invalid = input<boolean>(false);
    filter = input<boolean>(true);
    filterBy = input<string | null>(null);

    size = input<'small' | 'large'>('large');
    showClear = input<boolean>(true);
    fluid = input<boolean>(true);

    placeholder = input<string>('uiKit.form.dropdown.placeholder');
    emptyMessage = input<string>('');
    disabled = input<boolean>(false);

    appendTo = input<string | any>('body');

    onClear = output<void>();
    onHide = output<void>();
    onFocus = output<void>();
}
